import React, { useEffect, useState } from 'react';
import {
  Dimensions,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
  TextInput,
  TouchableOpacity,
  ScrollView,
  Modal,
  Image,
  ActivityIndicator,
  Alert,
} from 'react-native';
import { Picker } from '@react-native-picker/picker';
import axios from 'axios';
import { Formik } from 'formik';
import * as yup from 'yup';

import { BASE_URL } from '../../../components/BaseUrl';
import LeftBar from '../../../shared/LeftBar';
import ErrorText from '../../../shared/errorText';
import { globalStyles } from '../../../styles/globalStyles';
import moment from 'moment';

import { DatePickerModal } from 'react-native-paper-dates';
import { ThemeOne } from '../../../utils/constants/Colors';
import { useRoute } from '@react-navigation/native';
import LeftBarItemAdmin from '../../../shared/LeftBarItemAdmin';
import { adminMenus } from '../../../shared/adminMenus';

const Colors2 = ThemeOne;
const windowWidth = Dimensions.get('window').width;
const isWideWeb = Platform.OS === 'web' && windowWidth >= 600;

const basicInfoSchema = yup.object({
  divisionName: yup.string().required('Division is required'),
  districtName: yup.string().required('District is required'),
  grBranchId: yup.string().required('Lower Court is required'),
  
});

export const GrAllImageUploadComponent = () => {
  const route = useRoute();
  const locale = 'en';
  const pastDate = new Date(1900, 0, 1);
  const futureDate = new Date();

  // Geo/location dropdown data
  const [divisions, setDivisions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [lowerCourts, setLowerCourts] = useState([]);
  const [thanas, setThanas] = useState([]);

  // Create-form selections
  const [divisionId, setDivisionId] = useState('');
  const [districtId, setDistrictId] = useState('');
  const [lowerCourtId, setLowerCourtId] = useState('');
  const [thanaId, setThanaId] = useState('');
  const [causeDate, setCauseDate] = useState(new Date());
  const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);

  // Image upload states
  const [selectedImages, setSelectedImages] = useState([]);
  const [uploadingImages, setUploadingImages] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});

  const [allData, setAllData] = useState([]);
  const [searchDivisionId, setSearchDivisionId] = useState('');
  const [searchDistrictId, setSearchDistrictId] = useState('');
  const [searchThanaId, setSearchThanaId] = useState('');
  const [searchCauseDate, setSearchCauseDate] = useState(new Date());
  const [isSearchDatePickerVisible, setIsSearchDatePickerVisible] = useState(false);

  const [editDistricts, setEditDistricts] = useState([]);
  const [editLowerCourts, setEditLowerCourts] = useState([]);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editDivisionId, setEditDivisionId] = useState('');
  const [editDistrictId, setEditDistrictId] = useState('');
  const [editLowerCourtId, setEditLowerCourtId] = useState('');
  const [editLowerCourtName, setEditLowerCourtName] = useState('');

  const [isImageEditModalVisible, setIsImageEditModalVisible] = useState(false);
  const [editingImage, setEditingImage] = useState(null);
  const [uploadingUpdateImage, setUploadingUpdateImage] = useState(false);
  const [selectedUpdateImage, setSelectedUpdateImage] = useState(null);

  // ── Court Images Tree ──────────────────────────────────────────────────
  const [treeData, setTreeData] = useState([]);
  const [loadingTree, setLoadingTree] = useState(false);
  const [expandedBranch, setExpandedBranch] = useState({});
  const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
  const [uploadStationId, setUploadStationId] = useState(null);
  const [uploadStationName, setUploadStationName] = useState('');

  useEffect(() => {
    fetchDivisions();
  }, []);

  // ─── Date pickers ───────────────────────────────────────────────────────────

  const showDatePicker = () => setIsDatePickerVisible(true);
  const hideDatePicker = () => setIsDatePickerVisible(false);
  const handleDateConfirm = ({ date }) => {
    setCauseDate(date);
    hideDatePicker();
  };

  const showSearchDatePicker = () => setIsSearchDatePickerVisible(true);
  const hideSearchDatePicker = () => setIsSearchDatePickerVisible(false);
  const handleSearchDateConfirm = ({ date }) => {
    setSearchCauseDate(date);
    hideSearchDatePicker();
  };

  // ─── API: geo dropdowns ─────────────────────────────────────────────────────

  const fetchDivisions = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/GetDivission`);
      setDivisions(response.data || []);
    } catch (error) {
      console.log('Division Error:', error);
    }
  };

  const fetchDistrictsByDivision = async divisionId => {
    try {
      const formBody = `division_id=${encodeURIComponent(divisionId)}`;
      const response = await axios.post(`${BASE_URL}/DivisionToDistrict`, formBody, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      setDistricts(response.data || []);
      setThanaId('');
      setLowerCourtId('');
      setLowerCourts([]);
    } catch (error) {
      console.log('District Error:', error);
    }
  };

  const fetchEditDistrictsByDivision = async divisionId => {
    try {
      const formBody = `division_id=${encodeURIComponent(divisionId)}`;
      const response = await axios.post(`${BASE_URL}/DivisionToDistrict`, formBody, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      setEditDistricts(response.data || []);
    } catch (error) {
      console.log('District Error:', error);
    }
  };

  const fetchLowerCourtsByDistrict = async districtId => {
    setLowerCourts([]);
    try {
      const params = { geo_division_id: divisionId, geo_district_id: districtId, status: 1 };
      const response = await axios.get(`${BASE_URL}/GetGrbranchByDivisionAndDistrict`, {
        params,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      setLowerCourts(response.data || []);
      setThanaId('');
      setLowerCourtId('');
    } catch (error) {
      console.log('Lower Court Error:', error);
    }
  };

  const fetchThanasByBranch = async branchId => {
    try {
      const params = {
        geo_division_id: divisionId,
        geo_district_id: districtId,
        gr_branch_id: branchId,
        status: 1,
      };
      const response = await axios.get(`${BASE_URL}/GetAllPoliceStation`, {
        params,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      setThanas(response.data || []);
    } catch (error) {
      console.log('Thana Error:', error);
    }
  };

  const fetchEditLowerCourtsByDistrict = async districtId => {
    try {
      const params = { geo_division_id: editDivisionId, geo_district_id: districtId, status: 1 };
      const response = await axios.get(`${BASE_URL}/GetAllPoliceStation`, {
        params,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      setEditLowerCourts(response.data || []);
      setEditLowerCourtId('');
      setEditLowerCourtName('');
    } catch (error) {
      console.log('Lower Court Error:', error);
    }
  };

  // ─── API: GetGrTreeCourtImages ────────────────────────────────────────────

  const fetchCourtImages = async () => {
    if (!divisionId || !districtId || !causeDate) {
      alert('বিভাগ, জেলা এবং তারিখ নির্বাচন করুন');
      return;
    }
    setLoadingTree(true);
    try {
      const payload = {
        geo_division_id: divisionId,
        geo_district_id: districtId,
        gr_branch_id: lowerCourtId || null,
        cause_date: moment(causeDate).format('YYYY-MM-DD'),
      };
      const response = await axios.post(`${BASE_URL}/GetGrTreeCourtImages`, payload);
      setTreeData(response.data || []);
      setExpandedBranch({});
    } catch (error) {
      console.log('GetGrTreeCourtImages Error:', error);
      alert('তালিকা আনতে সমস্যা হয়েছে');
    } finally {
      setLoadingTree(false);
    }
  };

  const toggleBranch = key => {
    setExpandedBranch(prev => ({ ...prev, [key]: !prev[key] }));
  };

  // ─── Upload modal ──────────────────────────────────────────────────────────

  const openUploadModal = station => {
    setUploadStationId(station.id);
    setUploadStationName(station.name_bng);
    setSelectedImages([]);
    setIsUploadModalVisible(true);
  };

  const closeUploadModal = () => {
    if (uploadingImages) return;
    setIsUploadModalVisible(false);
    setSelectedImages([]);
    setUploadStationId(null);
    setUploadStationName('');
  };

  const handleUploadSubmit = async () => {
    if (selectedImages.length === 0) {
      alert('অন্তত একটি ছবি নির্বাচন করুন');
      return;
    }
    if (!uploadStationId) {
      alert('থানা/অঞ্চল নির্বাচিত হয়নি');
      return;
    }

    const formData = new FormData();
    selectedImages.forEach(image => formData.append('files', image.file, image.name));
    formData.append('cause_date', moment(causeDate).format('YYYY-MM-DD'));
    formData.append('diary_police_station_id', uploadStationId);

    try {
      setUploadingImages(true);
      await axios.post(`${BASE_URL}/UploadMultipleImages`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: progressEvent => {
          const progress = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
          setUploadProgress(prev => ({ ...prev, global: progress }));
        },
      });
      alert('ছবি সফলভাবে যোগ হয়েছে');
      setIsUploadModalVisible(false);
      setSelectedImages([]);
      setUploadStationId(null);
      setUploadStationName('');
      setUploadProgress({});
      fetchCourtImages();
    } catch (error) {
      console.log('Upload Error:', error?.response?.data || error.message);
      alert('ছবি আপলোড করতে সমস্যা হয়েছে');
    } finally {
      setUploadingImages(false);
    }
  };

  // ─── Image handling ─────────────────────────────────────────────────────────

  const mapFilesToImageState = files =>
    files
      .filter(file => file.type.startsWith('image/'))
      .map(file => ({
        file,
        preview: URL.createObjectURL(file),
        id: Date.now() + Math.random(),
        name: file.name,
        size: file.size,
        type: file.type,
      }));

  const handleImageSelect = event => {
    const newImages = mapFilesToImageState(Array.from(event.target.files));
    setSelectedImages(prev => [...prev, ...newImages]);
  };

  const handleUpdateImageSelect = event => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setSelectedUpdateImage({
        file,
        preview: URL.createObjectURL(file),
        name: file.name,
        size: file.size,
      });
    }
  };

  const handleDragOver = e => e.preventDefault();

  const handleDrop = e => {
    e.preventDefault();
    const newImages = mapFilesToImageState(Array.from(e.dataTransfer.files));
    setSelectedImages(prev => [...prev, ...newImages]);
  };

  const removeImage = imageId => {
    setSelectedImages(prev => {
      const removed = prev.find(img => img.id === imageId);
      if (removed?.preview) URL.revokeObjectURL(removed.preview);
      return prev.filter(img => img.id !== imageId);
    });
  };

  const formatFileSize = bytes => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1048576).toFixed(1)} MB`;
  };

  // ─── Search / Edit / Delete ────────────────────────────────────────────────

  const handleSearch = async () => {
    if (!searchDivisionId || !searchDistrictId) {
      alert('Please select both division and district to search');
      return;
    }
    try {
      const response = await axios.get(`${BASE_URL}/GetThanaImages`, {
        params: {
          diary_police_station_id: searchThanaId,
          status: 1,
          cause_date: searchCauseDate ? moment(searchCauseDate).format('YYYY-MM-DD') : undefined,
        },
      });
      if (response.status === 200) setAllData(response.data);
    } catch (error) {
      console.log('Get All Data Error:', error);
    }
  };

  const handleSubmitForm = async () => {
    if (selectedImages.length === 0) {
      alert('Please select at least one image');
      return;
    }
    if (!causeDate) {
      alert('Please select a date');
      return;
    }

    const formData = new FormData();
    selectedImages.forEach(image => formData.append('files', image.file, image.name));
    formData.append('cause_date', moment(causeDate).format('YYYY-MM-DD'));
    formData.append('diary_police_station_id', thanaId);

    try {
      setUploadingImages(true);
      await axios.post(`${BASE_URL}/UploadMultipleImages`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: progressEvent => {
          const progress = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
          setUploadProgress(prev => ({ ...prev, global: progress }));
        },
      });
      alert('Data added successfully');
      setSelectedImages([]);
      setUploadProgress({});
    } catch (error) {
      console.log('Submit Error:', error?.response?.data || error.message);
      alert('Error adding data');
    } finally {
      setUploadingImages(false);
    }
  };

  const handleUpdateImage = item => {
    setEditingImage(item);
    setSelectedUpdateImage(null);
    setIsImageEditModalVisible(true);
  };

  const handleDeleteImage = item => {
    Alert.alert('Confirm Delete', 'Are you sure you want to delete this image?', [
      { text: 'Cancel', style: 'cancel' },
      {
        text: 'Delete',
        style: 'destructive',
        onPress: async () => {
          try {
            await axios.delete(`${BASE_URL}/DeleteThanaImage/${item.id}`);
            alert('Image deleted successfully');
          } catch (error) {
            console.log('Delete Error:', error);
            alert('Error deleting image');
          }
        },
      },
    ]);
  };

  const handleSaveImageUpdate = async () => {
    if (!selectedUpdateImage && !editingImage) {
      alert('Please select a new image');
      return;
    }

    setUploadingUpdateImage(true);
    try {
      const formData = new FormData();
      if (selectedUpdateImage) {
        formData.append('file', selectedUpdateImage.file, selectedUpdateImage.name);
      }
      formData.append('id', editingImage.id);
      formData.append('cause_date', moment(searchCauseDate).format('YYYY-MM-DD'));
      formData.append('diary_police_station_id', searchThanaId);

      await axios.post(`${BASE_URL}/UpdateThanaImage`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      alert('Image updated successfully');
      setIsImageEditModalVisible(false);
      setEditingImage(null);
      setSelectedUpdateImage(null);
      handleSearch();
    } catch (error) {
      console.log('Update Error:', error);
      alert('Error updating image');
    } finally {
      setUploadingUpdateImage(false);
    }
  };

  const handleEditData = async item => {
    setIsEditModalVisible(true);
    setEditId(item.id);
    setEditDivisionId(item.geo_division_id?.toString());
    await fetchEditDistrictsByDivision(item.geo_division_id?.toString());
    setEditDistrictId(item.geo_district_id?.toString());
    await fetchEditLowerCourtsByDistrict(item.geo_district_id?.toString());
    setEditLowerCourtId(item.gr_branch_id?.toString());
    setEditLowerCourtName(item.name_bng?.toString());
  };

  const handleUpdateData = async () => {
    if (!editLowerCourtName || !editDivisionId || !editDistrictId) {
      alert('Please fill all fields');
      return;
    }

    const payload = {
      id: editId,
      geo_division_id: editDivisionId,
      geo_district_id: editDistrictId,
      gr_branch_id: editLowerCourtId,
      name_bng: editLowerCourtName,
      status: 1,
    };
    const formBody = Object.entries(payload)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');

    try {
      await axios.post(`${BASE_URL}/PoliceStationUpdate`, formBody);
      alert('Data updated successfully');
      handleCloseEditModal();
    } catch (error) {
      console.log('Update Error:', error);
      alert('Error updating data');
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setEditId(null);
    setEditDivisionId('');
    setEditDistrictId('');
    setEditLowerCourtId('');
    setEditLowerCourtName('');
    setEditDistricts([]);
    setEditLowerCourts([]);
  };

  // ─── Image Preview Renderer ─────────────────────────────────────────────────

  const renderImagePreview = () => {
    if (selectedImages.length === 0) return null;

    return (
      <View style={styles.imagePreviewContainer}>
        <View style={styles.previewSummaryRow}>
          <Text style={styles.imagePreviewTitle}>
            {selectedImages.length} image{selectedImages.length > 1 ? 's' : ''} selected
          </Text>
          <TouchableOpacity onPress={() => setSelectedImages([])} disabled={uploadingImages}>
            <Text style={styles.clearAllText}>Clear all</Text>
          </TouchableOpacity>
        </View>

        <View style={styles.previewCardsContainer}>
          {selectedImages.map(image => (
            <View key={image.id} style={styles.previewCard}>
              <Image source={{ uri: image.preview }} style={styles.imagePreview} />
              <TouchableOpacity
                style={styles.removeImageButton}
                onPress={() => removeImage(image.id)}
                disabled={uploadingImages}
              >
                <Text style={styles.removeImageText}>×</Text>
              </TouchableOpacity>
              {uploadProgress[image.id] > 0 && uploadingImages && (
                <View style={styles.uploadProgressOverlay}>
                  <Text style={styles.uploadProgressText}>{uploadProgress[image.id]}%</Text>
                </View>
              )}
              <View style={styles.previewFooter}>
                <Text style={styles.imageName} numberOfLines={1}>
                  {image.name}
                </Text>
                <Text style={styles.imageSize}>{formatFileSize(image.size)}</Text>
                {uploadProgress[image.id] > 0 && uploadingImages && (
                  <View style={styles.uploadBarWrap}>
                    <View style={[styles.uploadBar, { width: `${uploadProgress[image.id]}%` }]} />
                  </View>
                )}
              </View>
            </View>
          ))}
        </View>
      </View>
    );
  };

  // ─── Count total stations ──────────────────────────────────────────────────

  const getTotalStations = (data, type) => {
    let total = 0;
    data.forEach(branch => {
      if (type === 'with' && branch.with_image) {
        total += branch.with_image.length;
      } else if (type === 'without' && branch.without_image) {
        total += branch.without_image.length;
      }
    });
    return total;
  };

  // ─── Court Images Tree Renderer (Station-wise) ───────────────────────────

  const renderStationCards = (stations, hasImages) => {
    if (!stations || stations.length === 0) {
      return <Text style={styles.treeEmptyText}>কোনো থানা নাই</Text>;
    }

    return stations.map(station => (
      <View key={station.id} style={styles.stationCard}>
        <View style={styles.stationCardHeader}>
          <Text style={styles.stationCardTitle} numberOfLines={1}>
            {station.name_bng}
          </Text>
          <TouchableOpacity
            style={styles.stationUploadBtn}
            onPress={() => openUploadModal(station)}
          >
            <Text style={styles.stationUploadBtnText}>
              {hasImages ? '+ ছবি যোগ' : 'ছবি আপলোড'}
            </Text>
          </TouchableOpacity>
        </View>

        {hasImages && station.images && station.images.length > 0 && (
          <View style={styles.stationImagesRow}>
            {station.images.map(img => (
              <View key={img.id} style={styles.stationThumbWrap}>
                <Image
                  source={{ uri: 'https://api.bdjudgecourt.com' + img.file_path }}
                  style={styles.stationThumb}
                  resizeMode="cover"
                />
                <TouchableOpacity
                  style={styles.stationThumbEditBtn}
                  onPress={() => handleUpdateImage(img)}
                >
                  <Text style={styles.stationThumbEditBtnText}>এডিট</Text>
                </TouchableOpacity>
              </View>
            ))}
          </View>
        )}

        {hasImages && (!station.images || station.images.length === 0) && (
          <TouchableOpacity
            style={styles.stationEmptyUpload}
            onPress={() => openUploadModal(station)}
          >
            <Text style={styles.stationEmptyUploadText}>ছবি যোগ করুন</Text>
          </TouchableOpacity>
        )}
      </View>
    ));
  };

  // ─── Render ─────────────────────────────────────────────────────────────────

  return (
    <ScrollView>
      <View style={isWideWeb ? globalStyles.mainContainerAdmin : globalStyles.mainContainerMobile}>
        <LeftBar>
          {adminMenus.map((item, index) => (
            <LeftBarItemAdmin
              key={item.screen || index}
              activeScreen={route.name}
              name={item.name}
              stack={item.stack}
              screen={item.screen}
            />
          ))}
        </LeftBar>

        <View style={isWideWeb ? globalStyles.bodyContainer : globalStyles.bodyContainerMobile}>
          <View style={styles.stickyTopSection}>
            <View style={styles.formSectionContainer}>
              <Formik
                initialValues={{ divisionName: '', districtName: '', grBranchId: '', nameBng: '' }}
                validationSchema={basicInfoSchema}
                onSubmit={fetchCourtImages}
              >
                {({ handleChange, handleSubmit, setFieldValue, setFieldTouched, touched, errors }) => (
                  <View style={styles.formWrapper}>
                    {/* Division */}
                    <View style={styles.formGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={divisionId || ''}
                          style={styles.picker}
                          mode="dropdown"
                          onValueChange={itemValue => {
                            setDivisionId(itemValue);
                            fetchDistrictsByDivision(itemValue);
                            handleChange('divisionName')(itemValue);
                            setFieldTouched('divisionName', true);
                          }}
                        >
                          <Picker.Item label="বিভাগ নির্বাচন করুনঃ–" value="" color="red" />
                          {divisions.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.division_name_bng?.toString()}
                              value={item.geo_division_id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.divisionName && errors.divisionName && (
                        <ErrorText>{errors.divisionName}</ErrorText>
                      )}
                    </View>

                    {/* District */}
                    <View style={styles.formGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={districtId || ''}
                          style={styles.picker}
                          mode="dropdown"
                          onValueChange={itemValue => {
                            setDistrictId(itemValue);
                            setFieldValue('districtName', itemValue, true);
                            setFieldTouched('districtName', true, false);
                            fetchLowerCourtsByDistrict(itemValue);
                          }}
                        >
                          <Picker.Item label="জেলা নির্বাচন করুনঃ" value="" color="red" />
                          {districts.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.district_name_bng?.toString()}
                              value={item.geo_district_id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.districtName && errors.districtName && (
                        <ErrorText>{errors.districtName}</ErrorText>
                      )}
                    </View>

                    {/* Lower Court */}
                    <View style={styles.formGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={lowerCourtId || ''}
                          style={styles.picker2}
                          mode="dropdown"
                          onValueChange={itemValue => {
                            setLowerCourtId(itemValue);
                            setFieldValue('grBranchId', itemValue, true);
                            setFieldTouched('grBranchId', true, false);
                            fetchThanasByBranch(itemValue);
                          }}
                        >
                          <Picker.Item label="শাখার নাম নির্বাচন করুনঃ–" value="" color="red" />
                          {lowerCourts.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.name_bng?.toString()}
                              value={item.id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.grBranchId && errors.grBranchId && (
                        <ErrorText>{errors.grBranchId}</ErrorText>
                      )}
                    </View>

                    {/* Cause Date */}
                    <View style={styles.formGroup}>
                      <View style={styles.pickerWrapper}>
                        <TouchableOpacity onPress={showDatePicker} style={styles.sectionStyle}>
                          <TextInput
                            style={styles.inputs1}
                            value={causeDate ? moment(causeDate).format('DD-MM-YYYY') : ''}
                            placeholder="DD-MM-YYYY"
                            placeholderTextColor="#999"
                            editable={false}
                            pointerEvents="none"
                          />
                          <Image
                            source={{ uri: 'https://bdjudgecourt.com/assets/calendar.png' }}
                            style={styles.imageStyle}
                          />
                        </TouchableOpacity>
                      </View>
                      {!causeDate && <ErrorText>Please select a date</ErrorText>}
                    </View>
                    <TouchableOpacity
                      style={styles.treeSearchButton}
                      onPress={handleSubmit}
                      disabled={loadingTree}
                    >
                      <Text style={styles.submitButtonText}>
                        {loadingTree ? 'খুঁজছে…' : 'খুঁজুন'}
                      </Text>
                    </TouchableOpacity>
                  </View>
                )}
              </Formik>
            </View>
          </View>

          {/* Court Images Tree — Station-wise with_image / without_image side by side */}
          <View style={styles.treeSection}>
            <Text style={styles.listSectionTitle}>থানা অনুযায়ী কার্যতালিকার ছবি</Text>

            {loadingTree && (
              <View style={styles.treeLoadingRow}>
                <ActivityIndicator size="large" color="#378ADD" />
                <Text style={styles.uploadingText}>তালিকা লোড হচ্ছে...</Text>
              </View>
            )}

            {!loadingTree && (
              <View style={isWideWeb ? styles.treeColumnsRow : styles.treeColumnsRowMobile}>
                {/* Left column: Stations without images */}
                <View style={styles.treeColumn}>
                  <Text style={[styles.treeColumnTitle, styles.treeColumnTitleRed]}>
                    ছবি নাই ({getTotalStations(treeData, 'without')})
                  </Text>
                  {treeData.map(branch => (
                    <View key={branch.id}>
                      {renderStationCards(branch.without_image, false)}
                    </View>
                  ))}
                </View>

                {/* Right column: Stations with images */}
                <View style={styles.treeColumn}>
                  <Text style={[styles.treeColumnTitle, styles.treeColumnTitleGreen]}>
                    ছবি আছে ({getTotalStations(treeData, 'with')})
                  </Text>
                  {treeData.map(branch => (
                    <View key={branch.id}>
                      {renderStationCards(branch.with_image, true)}
                    </View>
                  ))}
                </View>
              </View>
            )}
          </View>

          <DatePickerModal
            locale={locale}
            mode="single"
            visible={isDatePickerVisible}
            onDismiss={hideDatePicker}
            date={causeDate || new Date()}
            onConfirm={handleDateConfirm}
            onChange={handleDateConfirm}
            validRange={{ startDate: pastDate, endDate: futureDate }}
          />

          <DatePickerModal
            locale={locale}
            mode="single"
            visible={isSearchDatePickerVisible}
            onDismiss={hideSearchDatePicker}
            date={searchCauseDate || new Date()}
            onConfirm={handleSearchDateConfirm}
            onChange={handleSearchDateConfirm}
            validRange={{ startDate: pastDate, endDate: futureDate }}
          />
        </View>
      </View>

      {/* Upload Modal */}
      <Modal animationType="slide" transparent visible={isUploadModalVisible} onRequestClose={closeUploadModal}>
        <View style={styles.modalOverlay}>
          <View style={styles.modalContainer}>
            <Text style={styles.modalTitle}>ছবি আপলোড</Text>
            {uploadStationName && (
              <Text style={styles.modalLabel}>
                {uploadStationName}
                {'  ·  '}
                {moment(causeDate).format('DD-MM-YYYY')}
              </Text>
            )}

            {Platform.OS === 'web' && (
              <div
                style={styles.dropzoneWeb}
                onClick={() => document.getElementById('treeUploadImageInput').click()}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                <input
                  type="file"
                  id="treeUploadImageInput"
                  accept="image/*"
                  multiple
                  style={{ display: 'none' }}
                  onChange={handleImageSelect}
                  disabled={uploadingImages}
                />
                <Text style={styles.dropzoneIconText}>📷</Text>
                <Text style={styles.dropzoneMainText}>
                  <Text style={styles.dropzoneBrowse}>ছবি বাছাই করুন</Text> অথবা ড্র্যাগ করে ছাড়ুন
                </Text>
                <Text style={styles.dropzoneSubText}>একাধিক ছবি একসাথে নির্বাচন করা যাবে</Text>
              </div>
            )}

            {renderImagePreview()}

            <View style={styles.modalButtonContainer}>
              <TouchableOpacity
                style={[styles.modalButton, styles.cancelButton]}
                onPress={closeUploadModal}
                disabled={uploadingImages}
              >
                <Text style={styles.cancelButtonText}>বাতিল</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.modalButton, styles.updateButton]}
                onPress={handleUploadSubmit}
                disabled={uploadingImages}
              >
                <Text style={styles.updateButtonText}>
                  {uploadingImages ? 'আপলোড হচ্ছে...' : 'আপলোড করুন'}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Image Edit Modal */}
      <Modal
        animationType="slide"
        transparent
        visible={isImageEditModalVisible}
        onRequestClose={() => setIsImageEditModalVisible(false)}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContainer}>
            <Text style={styles.modalTitle}>Update Image</Text>

            {editingImage && !selectedUpdateImage && (
              <>
                <Text style={styles.modalLabel}>Current Image</Text>
                <Image
                  source={{ uri: 'https://api.bdjudgecourt.com' + editingImage.file_path }}
                  style={styles.editImagePreview}
                  resizeMode="cover"
                />
              </>
            )}

            {selectedUpdateImage && (
              <>
                <Text style={styles.modalLabel}>New Image</Text>
                <Image source={{ uri: selectedUpdateImage.preview }} style={styles.editImagePreview} resizeMode="cover" />
                <Text style={styles.imageName}>{selectedUpdateImage.name}</Text>
                <Text style={styles.imageSize}>{formatFileSize(selectedUpdateImage.size)}</Text>
              </>
            )}

            <div style={styles.editDropzone} onClick={() => document.getElementById('updateImageInput').click()}>
              <input
                type="file"
                accept="image/*"
                id="updateImageInput"
                onChange={handleUpdateImageSelect}
                style={{ display: 'none' }}
                disabled={uploadingUpdateImage}
              />
              <Text style={styles.dropzoneIconText}>📷</Text>
              <Text style={styles.dropzoneMainText}>Click to select new image</Text>
            </div>

            <View style={styles.modalButtonContainer}>
              <TouchableOpacity
                style={[styles.modalButton, styles.cancelButton]}
                onPress={() => {
                  setIsImageEditModalVisible(false);
                  setEditingImage(null);
                  setSelectedUpdateImage(null);
                }}
              >
                <Text style={styles.cancelButtonText}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.modalButton, styles.updateButton]}
                onPress={handleSaveImageUpdate}
                disabled={uploadingUpdateImage}
              >
                <Text style={styles.updateButtonText}>
                  {uploadingUpdateImage ? 'Updating...' : 'Update'}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Edit Modal for Police Station */}
      <Modal animationType="slide" transparent visible={isEditModalVisible} onRequestClose={handleCloseEditModal}>
        <View style={styles.modalOverlay}>
          <View style={styles.modalContainer}>
            <Text style={styles.modalTitle}>Edit Data</Text>

            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Division</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editDivisionId || ''}
                  style={styles.modalPicker}
                  mode="dropdown"
                  onValueChange={async itemValue => {
                    setEditDivisionId(itemValue);
                    await fetchEditDistrictsByDivision(itemValue);
                    setEditDistrictId('');
                  }}
                >
                  <Picker.Item label="বিভাগ নির্বাচন করুনঃ–" value="" color="red" />
                  {divisions.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.division_name_bng?.toString()}
                      value={item.geo_division_id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>District</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editDistrictId || ''}
                  style={styles.modalPicker}
                  mode="dropdown"
                  onValueChange={async itemValue => {
                    setEditDistrictId(itemValue);
                    await fetchEditLowerCourtsByDistrict(itemValue);
                  }}
                >
                  <Picker.Item label="জেলা নির্বাচন করুনঃ–" value="" color="red" />
                  {editDistricts.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.district_name_bng?.toString()}
                      value={item.geo_district_id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Branch Name</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editLowerCourtId || ''}
                  style={styles.modalPicker}
                  mode="dropdown"
                  onValueChange={itemValue => {
                    setEditLowerCourtId(itemValue);
                    const selected = editLowerCourts.find(item => item.id?.toString() === itemValue);
                    setEditLowerCourtName(selected?.name_bng || '');
                  }}
                >
                  <Picker.Item label="শাখার নাম নির্বাচন করুনঃ–" value="" color="red" />
                  {editLowerCourts.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.name_bng?.toString()}
                      value={item.id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Thana / Area Name</Text>
              <View style={styles.modalInputWrapper}>
                <TextInput
                  placeholder="থানা / অঞ্চল লিখুন"
                  placeholderTextColor="#999"
                  style={styles.modalTextInput}
                  value={editLowerCourtName}
                  onChangeText={setEditLowerCourtName}
                  editable
                />
              </View>
            </View>

            <View style={styles.modalButtonContainer}>
              <TouchableOpacity style={[styles.modalButton, styles.cancelButton]} onPress={handleCloseEditModal}>
                <Text style={styles.cancelButtonText}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity style={[styles.modalButton, styles.updateButton]} onPress={handleUpdateData}>
                <Text style={styles.updateButtonText}>Update</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </ScrollView>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: 0,
    marginHorizontal: 10,
  },
  stickyTopSection: {
    position: Platform.OS === 'web' ? 'sticky' : 'relative',
    top: 0,
    zIndex: 20,
    paddingBottom: 0,
  },
  formSectionContainer: {
    width: '100%',
  },
  headerTexth: {
    fontSize: 20,
    fontWeight: 'bold',
    color: Colors2.top5,
    textAlign: 'left',
    marginLeft: 10,
  },
  formWrapper: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 12,
    paddingHorizontal: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  formGroup: {
    marginBottom: 14,
    marginHorizontal: 8,
  },
  pickerWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 4,
    backgroundColor: '#fff',
    overflow: 'hidden',
    height: 30,
  },
  sectionStyle: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    backgroundColor: '#fff',
    borderColor: '#000',
    borderRadius: 4,
    height: 30,
    position: 'relative',
  },
  imageStyle: {
    position: 'absolute',
    width: 20,
    height: 20,
    right: 8,
  },
  inputs1: {
    borderRadius: 2,
    fontSize: 13,
    width: 125,
    backgroundColor: '#fff',
    paddingLeft: 5,
  },
  picker: {
    height: isWideWeb ? 42 : 50,
    width: '100%',
    color: '#333',
  },
  picker2: {
    height: isWideWeb ? 42 : 50,
    width: '100%',
    color: '#333',
  },
  submitButton: {
    backgroundColor: '#007bff',
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 4,
    alignSelf: 'flex-start',
    marginLeft: '2%',
  },
  submitButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },

  // ── Image Upload Styles ──────────────────────────────────────────────────

  imageUploadSection: {
    width: '100%',
    marginTop: 14,
    marginBottom: 10,
    paddingHorizontal: 8,
  },
  imageUploadLabel: {
    fontSize: 11,
    fontWeight: '600',
    color: '#64748b',
    letterSpacing: 1,
    textTransform: 'uppercase',
    marginBottom: 10,
  },
  dropzoneWeb: {
    border: '1.5px dashed #94a3b8',
    borderRadius: 12,
    padding: '28px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 6,
    cursor: 'pointer',
    backgroundColor: '#f8fafc',
  },
  dropzoneIconText: {
    fontSize: 28,
    color: '#378ADD',
    marginBottom: 4,
    textAlign: 'center',
  },
  dropzoneMainText: {
    fontSize: 14,
    color: '#64748b',
    textAlign: 'center',
  },
  dropzoneBrowse: {
    color: '#185FA5',
    fontWeight: '600',
  },
  dropzoneSubText: {
    fontSize: 12,
    color: '#94a3b8',
    marginTop: 2,
    textAlign: 'center',
    paddingBottom: 16,
  },
  imagePreviewContainer: {
    marginTop: 14,
  },
  previewSummaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  imagePreviewTitle: {
    fontSize: 12,
    color: '#64748b',
    fontWeight: '500',
  },
  clearAllText: {
    fontSize: 12,
    color: '#A32D2D',
    fontWeight: '500',
  },
  previewCardsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  previewCard: {
    width: '31.33%',
    marginBottom: 10,
    borderWidth: 0.5,
    borderColor: '#e2e8f0',
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: '#fff',
  },
  imagePreview: {
    width: '100%',
    height: 160,
  },
  removeImageButton: {
    position: 'absolute',
    top: 4,
    right: 4,
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: 'rgba(226,75,74,0.9)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  removeImageText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 18,
  },
  uploadProgressOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 160,
    backgroundColor: 'rgba(0,0,0,0.55)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  uploadProgressText: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 'bold',
  },
  previewFooter: {
    padding: 8,
  },
  imageName: {
    fontSize: 11,
    color: '#64748b',
    marginBottom: 2,
  },
  imageSize: {
    fontSize: 10,
    color: '#94a3b8',
  },
  uploadBarWrap: {
    height: 3,
    backgroundColor: '#e2e8f0',
    borderRadius: 2,
    marginTop: 4,
    overflow: 'hidden',
  },
  uploadBar: {
    height: 3,
    backgroundColor: '#378ADD',
    borderRadius: 2,
  },
  uploadingIndicator: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: 10,
    padding: 10,
    backgroundColor: '#E6F1FB',
    borderRadius: 8,
    borderWidth: 0.5,
    borderColor: '#B5D4F4',
  },
  uploadingText: {
    marginLeft: 8,
    fontSize: 13,
    color: '#185FA5',
    fontWeight: '500',
  },

  // ── Edit Image Modal Styles ──────────────────────────────────────────────

  editImagePreview: {
    width: '100%',
    height: 200,
    borderRadius: 8,
    marginBottom: 10,
  },
  editDropzone: {
    border: '1.5px dashed #94a3b8',
    borderRadius: 12,
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    backgroundColor: '#f8fafc',
    marginTop: 10,
  },

  // ── Modal Styles ─────────────────────────────────────────────────────────

  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 20,
    width: '90%',
    maxWidth: 500,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    color: '#333',
  },
  modalFormGroup: {
    marginBottom: 15,
  },
  modalLabel: {
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 5,
    color: '#333',
  },
  modalPickerWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 8,
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  modalPicker: {
    height: 50,
    width: '100%',
    color: '#333',
  },
  modalInputWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 8,
    backgroundColor: '#fff',
  },
  modalTextInput: {
    height: 50,
    paddingHorizontal: 12,
    fontSize: 16,
    color: '#333',
  },
  modalButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    gap: 10,
  },
  modalButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  cancelButton: {
    backgroundColor: '#f5f5f5',
    borderWidth: 1,
    borderColor: '#ddd',
  },
  cancelButtonText: {
    color: '#666',
    fontSize: 16,
    fontWeight: '600',
  },
  updateButton: {
    backgroundColor: '#007bff',
  },
  updateButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },

  // ── Court Images Tree Styles (Station-wise) ─────────────────────────────

  treeSection: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 16,
    marginBottom: 30,
  },
  listSectionTitle: {
    fontSize: 15,
    fontWeight: '700',
    color: '#333',
    marginBottom: 12,
    paddingHorizontal: 4,
  },
  treeLoadingRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  treeColumnsRow: {
    flexDirection: 'row',
    gap: 12,
  },
  treeColumnsRowMobile: {
    flexDirection: 'column',
    gap: 12,
  },
  treeColumn: {
    flex: 1,
    backgroundColor: '#f8fafc',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#e2e8f0',
    padding: 10,
    minWidth: isWideWeb ? 0 : '100%',
  },
  treeColumnTitle: {
    fontSize: 13,
    fontWeight: '700',
    marginBottom: 10,
    paddingHorizontal: 2,
  },
  treeColumnTitleGreen: {
    color: '#2E9E6C',
  },
  treeColumnTitleRed: {
    color: '#A32D2D',
  },
  treeEmptyText: {
    fontSize: 12,
    color: '#94a3b8',
    paddingHorizontal: 2,
  },
  treeSearchButton: {
    backgroundColor: '#007bff',
    paddingVertical: 8,
    paddingHorizontal: 18,
    borderRadius: 4,
    alignSelf: 'flex-start',
    marginBottom: 8,
  },

  // ── Station Card Styles ─────────────────────────────────────────────────

  stationCard: {
    backgroundColor: '#fff',
    borderRadius: 8,
    borderWidth: 0.5,
    borderColor: '#e2e8f0',
    marginBottom: 8,
    padding: 10,
    overflow: 'hidden',
  },
  stationCardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  stationCardTitle: {
    fontSize: 13,
    fontWeight: '600',
    color: '#333',
    flex: 1,
    marginRight: 8,
  },
  stationUploadBtn: {
    backgroundColor: '#378ADD',
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 4,
  },
  stationUploadBtnText: {
    color: '#fff',
    fontSize: 10,
    fontWeight: '600',
  },
  stationImagesRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  stationThumbWrap: {
    width: 64,
    height: 64,
    borderRadius: 4,
    overflow: 'hidden',
    borderWidth: 0.5,
    borderColor: '#e2e8f0',
    position: 'relative',
  },
  stationThumb: {
    width: '100%',
    height: '100%',
  },
  stationThumbEditBtn: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0,0,0,0.55)',
    alignItems: 'center',
    paddingVertical: 2,
  },
  stationThumbEditBtnText: {
    color: '#fff',
    fontSize: 8,
    fontWeight: '600',
  },
  stationEmptyUpload: {
    backgroundColor: '#f1f5f9',
    paddingVertical: 8,
    borderRadius: 4,
    alignItems: 'center',
    borderWidth: 0.5,
    borderColor: '#e2e8f0',
    borderStyle: 'dashed',
  },
  stationEmptyUploadText: {
    fontSize: 10,
    color: '#94a3b8',
  },
});

export default GrAllImageUploadComponent;